import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
//import Button from '@material-ui/core/Button';
import { Col, Card, CardBody, Button, UncontrolledTooltip, Row, ButtonToolbar } from 'reactstrap';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import moment from 'moment';
import { withStyles } from "@material-ui/core/styles";
import MomentUtils from '@date-io/moment';
import "moment/locale/es";
import SearchIcon from '@material-ui/icons/Search';
import DataReactTable from './DataReactTable';
import history from '../../../../history';
import ReactTableActions from './ReactTableActions';
import Spinner from 'react-bootstrap/Spinner';
import AddIcon from '@material-ui/icons/Add';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faProcedures,
    faCrutch,
    faWheelchair,
    faHeadSideCough,
    faCircle,
    faPlusSquare,
    faLungs,
    faAmbulance,
    faAngleLeft,
    faAngleRight,
    faChevronCircleLeft,
    faChevronCircleRight,
    faUser,
    faDisease
} from "@fortawesome/free-solid-svg-icons";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import RequestReschedule from './RequestReschedule';
import ButtonMui from '@material-ui/core/Button';
import ButtonGroupMui from '@material-ui/core/ButtonGroup';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import AlergiesListToShow from '../../../Patient/DisplayPatientInformation/components/alergies/components/AlergiesListToShow';
import pdfAdmsionFormat from '../../../ClinicHistory/ClinicEvent/components/PdfReports/PdfAdmisionFormat';
import Modal from '@material-ui/core/Modal';
import CloseIcon from '@material-ui/icons/Close';


const defaultMaterialTheme = createMuiTheme({
    palette: {
        primary: {
            main: '#3EA3FC',
            contrastText: "#fff"
        },

    },
});

const styles = theme => ({
    date: {
        margin: 10
    }
});

class FormAdmissions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: '',
            typeOfDocument: '',
            names: '',
            firstLastName: '',
            secondLastName: '',
            date: null,
            datetwo: null,
            admission: '',
            history: '',
            data: [],
            load: false,
            fecha: new Date(),
            isLoading: true,
            pacient: [],
            stateAdmision: 'Abierta',
            indexPage: 0,
            openModalAlergies: false,
            currentPatientInfo: null,
            askSpecialReq: false,
            showPDFCertAdmission: false,
            colorStateFallingRisks: '#6F6964',
            askFallingRisk: false,
            showAlergies: false
        };
    };

    static getDerivedStateFromProps(props, states) {
        if ((typeof props.location !== 'undefined') &&
            (typeof props.location.state !== 'undefined') &&
            (states.location_key !== props.location.key)) {
            let newState = props.location.state;
            newState.location_key = props.location.key;
            return newState;
        }
        return null;
    }

    componentDidMount() {
        let clinica = JSON.parse(sessionStorage.getItem('clinica'));
        let showPDFAdmission = clinica.hasOwnProperty('mostrar_cert_admision') ? clinica.mostrar_cert_admision : false;
        if (history.location.state !== null && showPDFAdmission) {
            if (!!history.location.state.dataSendCertAdmission) {
                this.makePdfAdmsionFormat();
            }
        }
        if (history.location.state !== null && typeof history.location.state.estado_form !== 'undefined') {
            this.setState({
                stateAdmision: history.location.state.estado_form?.estado,
                datetwo: history.location.state.estado_form?.fecha,
                date: history.location.state.estado_form?.fecha,
                admission: history.location.state.estado_form?.id_admision,
                history: history.location.state.estado_form?.id_historia,
                id: history.location.state.estado_form?.num_documento,
                indexPage: history.location.state.indexPageF
            }, () => {
                if (this.state.id !== null && this.state.id !== undefined) {
                    this.loadIdentity();
                    console.log("indexPageF", this.state.indexPage);
                }
            });
            this.searchAdmissions(history.location.state.estado_form?.estado, true, false);
        } else {
            this.setState({ stateAdmision: 'Abierta', date: moment(new Date()) });
            this.searchAdmissions(this.state.stateAdmision, true, false);
        }
        //Esteban Londoño Ospina 23/11/2021
        //Funcion que va actualizando la lista de las Admisiones cada vez que se agrega una nueva
        const searchAdmisionQuery = () => {
            if (this.state.data.length <= 0) {
                if (history.location.state !== null && typeof history.location.state.estado_form !== 'undefined') {
                    this.setState({
                        datetwo: history.location.state.estado_form?.fecha,
                    })
                    /* const hoy = new Date();
                    this.setState({ date: moment(hoy) }); */
                } else {
                    const hoy = new Date();
                    this.setState({ date: moment(hoy) });
                }
                /* if (history.location.state !== this.state) {
                    console.log("Thes",history.location.state !== this.state, "estado", this.state, "props", history.location.state)
                    this.setState(history.location.state, () => {
                    });
                } else {
                    console.log("Thes2", history.location.state !== this.state, "estado", this.state, "props", history.location.state);
                    history.replace({ state: this.state });
                } */
            }
            //this.searchAdmissions(this.state.stateAdmision, true, false);
        };
        this.validateShowInfoClinic();
        searchAdmisionQuery();
    }

    componentWillUnmount() {
    }

    handlerDocumentNumber = (id) => {
        this.setState({ id: id }, () => {
            this.loadIdentity();
        });
    }

    loadIdentity = () => {
        var data = { num_documento: this.state.id };
        fetch(process.env.REACT_APP_PUBLIC_URL + 'paciente/consultar', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(data)
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                if (data.existe) {
                    console.log(data.contenido[0]);
                    this.setState({
                        names: data.contenido[0].nombres,
                        firstLastName: data.contenido[0].apellido1,
                        secondLastName: data.contenido[0].apellido2,
                        //history: data.contenido[0].id_historia
                    });
                } else {
                    this.setState({
                        names: '',
                        firstLastName: '',
                        secondLastName: '',
                        history: ''
                    });
                }
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    handlerTypeOfDocument = (type) => {
        this.setState({ typeOfDocument: type });
    }

    handlerNames = (name) => {
        this.setState({ names: name.toString().toUpperCase() });
    }

    handlerFirstLastName = (name) => {
        this.setState({ firstLastName: name.toString().toUpperCase() });
    }

    handlerSecondLastName = (name) => {
        this.setState({ secondLastName: name.toString().toUpperCase() });
    }

    handlerDate = (date) => {
        if (new Date(date)) {
            this.setState({ date: date, datetwo: null });

        } else {
            this.setState({ date: null });
        }
    };

    handlerAdmission = (admission) => {
        this.setState({ admission: admission });
    };

    handlerHistoryNumber = (history) => {
        this.setState({ history: history });
    }

    handlerStateAdmision = (stateAdmision) => {
        this.setState({ stateAdmision: stateAdmision });
    }

    handlerPageIndex = (pageIndex) => {
        this.setState({ indexPage: pageIndex });
    }

    verifyColorStateAdmission = (state) => {
        let stateColor = '#808080';
        if (state === "Abierta") {
            stateColor = '#40F400';
        } else if (state === "Cerrada") {
            stateColor = '#FF0000';
        } else if (state === "Cancelada") {
            stateColor = '#FFFF00';
        } else {
            stateColor = '#808080';
        }
        return stateColor
    }

    validateAllFields = (data) => {
        if (
            (data.id_admision == undefined || data.id_admision == null || data.id_admision == 0 || data.id_admision == "0" || data.id_admision == "") && //id_admision
            (data.num_documento == undefined || data.num_documento == null || data.num_documento == 0 || data.num_documento == "0" || data.num_documento == "") && //num_documento
            (data.fecha == undefined || data.fecha == null || data.fecha == 0 || data.fecha == "0" || data.fecha == "") && //fecha
            (data.nombres == undefined || data.nombres == null || data.nombres == 0 || data.nombres == "0" || data.nombres == "") && //nombres
            (data.apellido1 == undefined || data.apellido1 == null || data.apellido1 == 0 || data.apellido1 == "0" || data.apellido1 == "") && //apellido1
            (data.apellido2 == undefined || data.apellido2 == null || data.apellido2 == 0 || data.apellido2 == "0" || data.apellido2 == "") && //apellido2
            (data.tip_documento == undefined || data.tip_documento == null || data.tip_documento == 0 || data.tip_documento == "0" || data.tip_documento == "") //tip_documento
        ) {
            return false;
        }
        else {
            return true;
        }
    }

    searchAdmissions = (estado, flickeringEffect, isClick) => {
        this.setState({ load: true, isLoading: true }, () => {
            let id_usuario = JSON.parse(sessionStorage.getItem('usuario')).id_usuario;
            let data = {
                id_admision: this.state.admission !== "" ? parseInt(this.state.admission) : 0,
                id_historia: this.state.history !== "" && this.state.history != null ? parseInt(this.state.history) : 0,
                num_documento: this.state.id !== "" ? this.state.id : "0",
                fecha: this.state.datetwo !== null ? this.state.datetwo : this.state.date !== null ? moment(this.state.date).format('YYYY-MM-DD') : 0,
                estado: estado,
                nombres: this.state.names,
                apellido1: this.state.firstLastName,
                apellido2: this.state.secondLastName,
                tip_documento: this.state.typeOfDocument,
                id_usuario: id_usuario
            };

            let validate = this.validateAllFields(data);

            if (!validate) {
                if (isClick) {
                    alert("Debe enviar como minimo un parametro de busqueda aparte del Estado de la Admisión");
                }
                this.setState({ load: false, isLoading: false });
                return;
            }

            fetch(process.env.REACT_APP_PUBLIC_URL + 'admision/consultar', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(data)
            }).then(response => {
                return response.json();
            }).then(data => {
                this.setState({ pacient: data.contenido[0] })
                if (data.existe) {
                    var data = data.contenido;
                    console.log("admision/consultar", data.contenido)
                    data.map((value) => {
                        value.fecha = moment(value.fecha).format("YYYY-MM-DD");
                        value.id_admision = value.id_admision.toString();
                        value.estado_form = {
                            id_admision: this.state.admission !== "" ? parseInt(this.state.admission) : "",
                            id_historia: this.state.history !== "" && this.state.history != null ? parseInt(this.state.history) : "",
                            num_documento: this.state.id !== "" ? this.state.id : "",
                            fecha: this.state.datetwo !== null ? this.state.datetwo : this.state.date !== null ? this.state.date.format('YYYY-MM-DD') : null,
                            estado: estado,
                            nombres: this.state.names,
                            apellido1: this.state.firstLastName,
                            apellido2: this.state.secondLastName,
                            tip_documento: this.state.typeOfDocument,
                            indexPage: this.state.indexPage
                        };
                        return data;
                    });

                    if (sessionStorage.getItem('perfil') === '16')
                        this.filterDataTecnologo(data, flickeringEffect);
                    else
                        this.filterData(data, flickeringEffect);

                    this.setState({ load: false, isLoading: false })
                } else {
                    this.setState({ isLoading: false, data: [] })
                }
            }).catch((error) => {
                console.error('Error:', error);
            });
        })
    }

    filterData = (data, flickeringEffect) => {
        let orderData = [];
        for (let i = 0; i < data.length; i++) {

            let serNombre = "";
            if (data[i].servicio.servicios.length > 1) {
                for (let k = 0; k < data[i].servicio.servicios.length; k++) {
                    if (data[i].servicio.servicios[k].codigo != null && data[i].servicio.servicios[k].codigo != undefined) {
                        serNombre += data[i].servicio.servicios[k].codigo;
                        if (k < data[i].servicio.servicios.length - 1) {
                            serNombre += " - ";
                        }
                    }
                    else if (data[i].servicio.servicios[k].cupscod != null && data[i].servicio.servicios[k].cupscod != undefined) {
                        serNombre += data[i].servicio.servicios[k].cupscod;
                        if (k < data[i].servicio.servicios.length - 1) {
                            serNombre += " - ";
                        }
                    }
                }
            }
            else {
                serNombre = data[i].servicio.servicios[0] != undefined ? data[i].servicio.servicios[0].nombre : "";
            }

            let caidasAdm = null;

            if (data[i].caidas != null) {
                caidasAdm = data[i].caidas;
            }
            else if (data[i].caidas_cita != null) {
                caidasAdm = data[i].caidas_cita;
            }
            else {
                caidasAdm = null;
            }

            orderData[i] = {
                num_documento: data[i].num_documento,
                fullname: data[i].apellido2 != null ? data[i].nombres + " " + data[i].apellido1 + " " + data[i].apellido2 : data[i].nombres + " " + data[i].apellido1,
                tip_documento: data[i].tip_documento,
                fecha: data[i].fecha,
                birthday: data[i].fec_nacimiento,
                id_admision: data[i].id_admision,
                hora: data[i].hora,
                id_historia: data[i].id_historia,
                id_paciente: data[i].id_paciente,
                direccion: data[i].direccion,
                notas: data[i].notas,
                id_cita: data[i].id_cita,
                //correctos: tenCorrect,
                estado: data[i].estado,
                archivos: data[i].archivos,
                caidas: caidasAdm,
                pertenece_estudio: data[i].pertenece_estudio,
                servicios: data[i].pertenece_estudio ? data[i].estudio_detalle.detalle.visita : data[i].servicio.servicios,
                servName: data[i].pertenece_estudio ? data[i].estudio_detalle.detalle.visita.nombre : serNombre,
                celular: data[i].celular,
                telefono: data[i].telefono1,
                correo: data[i].correo,
                direccion: data[i].direccion !== null ? data[i].direccion.direccion : "",
                id_visita: data[i].estudio_detalle != null ? data[i].estudio_detalle.detalle.visita.id_visita : null,
                id_estudio: data[i].estudio_detalle != null ? data[i].estudio_detalle.detalle.estudio_clinico.id_estudio : null,
                estado_imagenes: data[i].estado_imagenes != null ? data[i].estado_imagenes : null,
                estado_medico: data[i].estado_medico != null ? data[i].estado_medico : null,
                fecha_ingreso_completa: data[i].fecha_ingreso_completa != null ? moment(data[i].fecha_ingreso_completa).format('h:mm:ss a') : null,
                fecha_ingreso_admision: data[i].fecha_ingreso_completa != null ? moment(data[i].fecha_ingreso_completa).format('DD-MM-YYYY') : null,
                fecha_cita: data[i].fecha_cita != null ? moment(data[i].fecha_cita).format('h:mm:ss a') : null,
                fecha_cita_ddmmyyyy: data[i].fecha_cita != null ? moment(data[i].fecha_cita).format('DD-MM-YYYY') : null,
                destacar: this.verifyEffectText(data[i], flickeringEffect),
                pago: data[i].recibo_pago,
                remitente: data[i].remitente,
                peso: data[i].peso,
                talla: data[i].talla,
                id_tecnologo: data[i].tecnologo,
                id_usuario_profesional: data[i].id_usuario_profesional,
                existen_imagenes_diagnosticas: this.validateDiagnosticImages(data[i].archivos),
                requerimientos_especiales: data[i].requerimientos_especiales,
                correctos: data[i].correctos,
                id_tercero: data[i].id_tercero,
                nombre_tercero: data[i].nombre_tercero,
                nit_tercero: data[i].nit_tercero,
                telefono_tercero: data[i].telefono_tercero,
                correo_tercero: data[i].correo_tercero,
                direccion_tercero: data[i].direccion_tercero,
                entrevista_realizada: data[i].entrevista_realizada,
                radiofarmaco_aplicado: data[i].radiofarmaco_aplicado,
                canalizacion_radiofarmaco: data[i].canalizacion_radiofarmaco,
                nombre_profesional: data[i].nombre_profesional,
                reagendamiento_solicitado: data[i].reagendamiento_solicitado,
                motivo_reagendamiento: data[i].motivo_reagendamiento,
                id_admision_cita_padre: data[i].id_admision_cita_padre,
                id_factura_t: data[i].id_factura_t,
                factura_folio: data[i].factura_folio,
                consentimiento_informado: data[i].consentimiento_informado,
                consentimiento_informado_validado: data[i].consentimiento_informado_validado,
                otros_procedimientos: data[i].procedimiento_realizado,
                consentimiento_no_reembolso: data[i].consentimiento_no_reembolso,
                regimen_admision: data[i].regimen_admision,
                estado_form: data[i].estado_form,
                honorario_medico: data[i].honorario_medico,
                paciente_migrado: data[i].aplicativo_migrado,
                id_estudio_paciente: data[i].id_estudio_paciente,
                actividades_realizadas: data[i].actividades_realizadas,
                has_alergies: data[i].alergias_paciente,
                planName: data[i].nombre_plan,
                invoiceNote: data[i].nota_factura,
                thirdsName: data[i].nombre_tercero,
                aislamiento: data[i].aislamiento,
            }
        }
        this.setState({ data: orderData });
    }

    filterDataTecnologo = (data, flickeringEffect) => {

        let orderData = [];
        let isConsult = false;

        for (let obj of data) {


            for (let k = 0; k < obj.servicio.servicios.length; k++) {

                if (obj.servicio.servicios[k].tipo != null) {
                    if (obj.servicio.servicios[k].tipo === 3)
                        isConsult = true;
                } else {
                    if (obj.servicio.servicios[k].id_rips_concepto === 1)
                        isConsult = true;

                }

            }

            if (!isConsult) {

                let serNombre = "";

                if (obj.servicio.servicios.length > 1) {


                    for (let k = 0; k < obj.servicio.servicios.length; k++) {
                        if (obj.servicio.servicios[k].cupscod != null && obj.servicio.servicios[k].cupscod != undefined) {
                            serNombre += obj.servicio.servicios[k].cupscod;
                            if (k < obj.servicio.servicios.length - 1) {
                                serNombre += " - ";
                            }
                        }
                        else if (obj.servicio.servicios[k].codigo != null && obj.servicio.servicios[k].codigo != undefined) {
                            serNombre += obj.servicio.servicios[k].codigo;
                            if (k < obj.servicio.servicios.length - 1) {
                                serNombre += " - ";
                            }
                        }
                    }
                }
                else {
                    serNombre = obj.servicio.servicios[0] != undefined ? obj.servicio.servicios[0].nombre : "";
                }


                orderData.push({
                    num_documento: obj.num_documento,
                    fullname: obj.apellido2 !== null ? obj.nombres + " " + obj.apellido1 + " " + obj.apellido2 : obj.nombres + " " + obj.apellido1,
                    tip_documento: obj.tip_documento,
                    fecha: obj.fecha,
                    birthday: obj.fec_nacimiento,
                    id_admision: obj.id_admision,
                    hora: obj.hora,
                    id_historia: obj.id_historia,
                    id_paciente: obj.id_paciente,
                    direccion: obj.direccion,
                    notas: obj.notas,
                    id_cita: obj.id_cita,
                    //correctos: tenCorrect,
                    estado: obj.estado,
                    archivos: obj.archivos,
                    caidas: obj.caidas,
                    pertenece_estudio: obj.pertenece_estudio,
                    servicios: obj.pertenece_estudio ? obj.estudio_detalle.detalle.visita : obj.servicio.servicios,
                    servName: obj.pertenece_estudio ? obj.estudio_detalle.detalle.visita.nombre : serNombre,
                    celular: obj.celular,
                    telefono: obj.telefono1,
                    direccion: obj.direccion !== null ? obj.direccion.direccion : "",
                    id_visita: obj.estudio_detalle != null ? obj.estudio_detalle.detalle.visita.id_visita : null,
                    id_estudio: obj.estudio_detalle != null ? obj.estudio_detalle.detalle.estudio_clinico.id_estudio : null,
                    estado_imagenes: obj.estado_imagenes != null ? obj.estado_imagenes : null,
                    estado_medico: obj.estado_medico != null ? obj.estado_medico : null,
                    fecha_ingreso_completa: obj.fecha_ingreso_completa != null ? moment(obj.fecha_ingreso_completa).format('h:mm:ss a') : null,
                    fecha_cita: obj.fecha_cita != null ? moment(obj.fecha_cita).format('h:mm:ss a') : null,
                    destacar: this.verifyEffectText(obj, flickeringEffect),
                    pago: obj.recibo_pago,
                    remitente: obj.remitente,
                    peso: obj.peso,
                    talla: obj.talla,
                    id_tecnologo: obj.tecnologo,
                    id_usuario_profesional: obj.id_usuario_profesional,
                    correo: obj.correo,
                    correctos: obj.correctos,
                    id_tercero: obj.id_tercero,
                    nombre_tercero: obj.nombre_tercero,
                    nit_tercero: obj.nit_tercero,
                    telefono_tercero: obj.telefono_tercero,
                    correo_tercero: obj.correo_tercero,
                    direccion_tercero: obj.direccion_tercero,
                    entrevista_realizada: obj.entrevista_realizada,
                    radiofarmaco_aplicado: obj.radiofarmaco_aplicado,
                    canalizacion_radiofarmaco: obj.canalizacion_radiofarmaco,
                    nombre_profesional: obj.nombre_profesional,
                    reagendamiento_solicitado: obj.reagendamiento_solicitado,
                    motivo_reagendamiento: obj.motivo_reagendamiento,
                    id_admision_cita_padre: obj.id_admision_cita_padre,
                    id_factura_t: obj.id_factura,
                    factura_folio: obj.factura_folio,
                    consentimiento_informado: obj.consentimiento_informado,
                    consentimiento_informado_validado: obj.consentimiento_informado_validado,
                    consentimiento_no_reembolso: obj.consentimiento_no_reembolso,
                    regimen_admision: obj.regimen_admision,
                    estado_form: obj.estado_form,
                    honorario_medico: obj.honorario_medico,
                    paciente_migrado: obj.aplicativo_migrado,
                    id_estudio_paciente: obj.id_estudio_paciente,
                    actividades_realizadas: obj.actividades_realizadas,
                    has_alergies: obj.alergias_paciente,
                    planName: obj.nombre_plan,
                    invoiceNote: obj.nota_factura,
                    thirdsName: obj.nombre_tercero
                })

            } else {
                isConsult = false;
            }
        }
        this.setState({ data: orderData });
    }

    validateDiagnosticImages(dataFiles) {
        console.log(dataFiles);
        if (dataFiles != undefined && dataFiles != null) {
            return true;
        } else {
            return false;
        }
    }

    verifyEffectText(data_admision, flickeringEffect) {
        let verifiedEffect = false;
        if (moment(this.state.date).format('YYYY-MM-DD') == moment(new Date()).format('YYYY-MM-DD') && this.state.data.length > 0 && flickeringEffect == true) {
            verifiedEffect = this.state.data.some(data_adm => data_adm.id_admision == data_admision.id_admision) == true ? false : true;
            console.log(verifiedEffect);
        }
        return verifiedEffect;
    }

    callbackRadioPharmacy = (id_admision, valuePharma) => {
        let dataNew = this.state.data.filter(adm => adm.id_admision != null);
        let index = dataNew.findIndex(adm => adm.id_admision == id_admision);
        dataNew[index].radiofarmaco_aplicado = valuePharma;
        this.setState({ data: dataNew });
    }

    callbackFallingRisks = (id_admision, valueCaidas) => {
        let dataNew = this.state.data.filter(adm => adm.id_admision != null);
        let index = dataNew.findIndex(adm => adm.id_admision == id_admision);
        dataNew[index].caidas = valueCaidas;
        this.setState({ data: dataNew });
    }

    callbackTenCorrect = (id_admision, valueTen) => {
        let dataNew = this.state.data.filter(adm => adm.id_admision != null);
        let index = dataNew.findIndex(adm => adm.id_admision == id_admision);
        dataNew[index].correctos = valueTen;
        this.setState({ data: dataNew });
    }

    callbackupdateCanalization = (id_admision, value) => {
        let newData = this.state.data.filter(adm => adm.id_admision != null);
        let index = newData.findIndex(adm => adm.id_admision == id_admision);
        newData[index].canalizacion_radiofarmaco = value;
        this.setState({ data: newData })
    }

    callbackHealthProfessional = (id_admision, professionalData) => {
        let newData = this.state.data.filter(adm => adm.id_admision != null);
        let index = newData.findIndex(adm => adm.id_admision == id_admision);
        newData[index].nombre_profesional = professionalData.nombre_profesional;
        newData[index].id_usuario_profesional = professionalData.id_usuario;
        this.setState({ data: newData });
    }

    callbackHealthProfessional = (id_admision, value) => {
        let newData = this.state.data.filter(adm => adm.id_admision != null);
        let index = newData.findIndex(adm => adm.id_admision == id_admision);
        newData[index].actividades_realizadas = true;
        this.setState({ data: newData });
    }

    validateShowInfoClinic = () => {
        let clinica = JSON.parse(sessionStorage.getItem('clinica'));
        this.setState({ 
        askSpecialReq: clinica.hasOwnProperty('solicitar_req_especiales') ? clinica.solicitar_req_especiales : false, 
        askFallingRisk: clinica.hasOwnProperty('solicitar_riesdo_caida') ? clinica.solicitar_riesdo_caida : false,
        showAlergies: !!clinica ? clinica.hasOwnProperty('ver_alergias_listado_hc_adm') ? clinica.ver_alergias_listado_hc_adm : false : false })
    }

    goToSelectedDate = (date, forward, backward) => {
        let today = moment(new Date());
        let dateToGo = null;
        if (date !== null && date !== undefined) {
            if (backward) {
                dateToGo = moment(date).subtract(1, 'day');
                this.setState({ date: dateToGo, datetwo: null, indexPage: 0 }, () => {
                    console.log("DAY", moment(this.state.date).format("DD-MM-YYYY"), "DAYSTATE", this.state.date)
                    this.searchAdmissions(this.state.stateAdmision, false, true);
                });
            } else if (forward) {
                dateToGo = moment(date).add(1, 'day');
                this.setState({ date: dateToGo, datetwo: null, indexPage: 0 }, () => {
                    console.log("DAY", moment(this.state.date).format("DD-MM-YYYY"), "DAYSTATE", this.state.date)
                    this.searchAdmissions(this.state.stateAdmision, false, true);
                });
            } else {
                dateToGo = today;
                this.setState({ date: dateToGo, datetwo: null, indexPage: 0 }, () => {
                    console.log("DAY", moment(this.state.date).format("DD-MM-YYYY"), "DAYSTATE", this.state.date)
                    this.searchAdmissions(this.state.stateAdmision, false, true);
                });
            }
        }
    }

    handlerOpenModalAlergies = (event, currentPatient) => {
        this.setState({ openModalAlergies: event, currentPatientInfo: currentPatient })
    }


    loadCertTemplete = () => {
        return new Promise((resolve, reject) => {
            fetch(process.env.REACT_APP_PUBLIC_URL + 'pantillas-cert-admision/listar', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                }
            })
                .then(response => {
                    if (response.status != 500 && response.status != 403) {
                        return response.json();
                    }
                    else {
                        throw new Error("Ha ocurrido un error en el servidor");
                    }
                })
                .then(data => {
                    console.log('dataPlantilla', data);

                    if (data !== undefined && data !== null) {
                        if (data.length > 0) {
                            resolve(data);
                        } else {
                            resolve([]);
                        }
                    }
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        })
    }

    makePdfAdmsionFormat = async () => {
        let FromProps = history.location.state.dataSendCertAdmission;
        let infoTempleteCertAdmission = await this.loadCertTemplete();
        let dataToPDF = FromProps;
        let plantillaCertAdmision = null;
        if (infoTempleteCertAdmission !== undefined && infoTempleteCertAdmission !== null) {
            if (infoTempleteCertAdmission[0].plantilla_certificado_admision !== '') {
                let servicesAdmission = ''
                let servicesFromAppointment = FromProps.servicios;
                servicesFromAppointment.reduce((acc, current) => {
                    servicesAdmission = servicesAdmission.concat(current.servicios + ' - ');
                }, '')
                plantillaCertAdmision = infoTempleteCertAdmission[0].plantilla_certificado_admision.toString();
                plantillaCertAdmision = plantillaCertAdmision.replaceAll('{paciente}', FromProps.names);
                plantillaCertAdmision = plantillaCertAdmision.replaceAll('{procedimiento}', servicesAdmission);
                plantillaCertAdmision = plantillaCertAdmision.replaceAll('{identidad}', FromProps.documentNumber);
                plantillaCertAdmision = plantillaCertAdmision.replaceAll('{tipo_identidad}', FromProps.typeOfDocument);
                plantillaCertAdmision = plantillaCertAdmision.replaceAll('{empresa}', FromProps.profile?.nombre);
                plantillaCertAdmision = plantillaCertAdmision.replaceAll('{profesional}', FromProps.professional?.nombre_profesional);
                plantillaCertAdmision = plantillaCertAdmision.replaceAll('{direccion}', FromProps.profile?.direccion?.direccion);
                plantillaCertAdmision = plantillaCertAdmision.replaceAll('<p>', '<div>');
                plantillaCertAdmision = plantillaCertAdmision.replaceAll('</p>', '</div>');
                dataToPDF.templete = plantillaCertAdmision;
            }
        }
        this.setState({ showPDFCertAdmission: true });
        pdfAdmsionFormat(dataToPDF);
    }

    handlerClosePDF = () => {
        this.setState({ showPDFCertAdmission: !this.state.showPDFCertAdmission })
    }

    verifyColorRisk = (caidas) => {
        let colorSelected = '#6F6964';
        if (caidas.riesgo !== '') {
            switch (caidas.riesgo) {
                case 'Bajo':
                    colorSelected = '#00D51A';
                    break;
                case 'Alto':
                    colorSelected = '#F71C06';
                    break;
                case 'Medio':
                    colorSelected = '#F7EF06';
                    break;
                default:
                    colorSelected = '#6F6964';
                    break;
            }
        } else {
            colorSelected = '#6F6964';
        }
        return colorSelected
    }

    render() {
        let reactTableData = {
            tableHeaderData: [
                {
                    Header: 'N° ADMISIÓN',
                    accessor: 'id_admision',
                    disableGlobalFilter: true,
                    width: 65,
                    Cell: row => (
                        <div className={`admision-new ${row.data[row.row.index].destacar == true ? 'effect-admision-new' : null}`} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: 0 }}>
                            <div>{row.value}</div>
                            <div><p><b>Estado:</b></p> </div>
                            <div><p><FontAwesomeIcon icon={faCircle} style={{ color: this.verifyColorStateAdmission(row.row.original.estado) }} /> &nbsp;{row.row.original.estado != 'Cancelada' ? row.row.original.estado : "Anulada"}</p></div>
                        </div>)
                },
                {
                    Header: 'DOCUMENTO',
                    accessor: 'tip_documento',
                    Cell: row => (
                        <div className={`admision-new ${row.data[row.row.index].destacar == true ? 'effect-admision-new' : null}`}>
                            <div className='info-pacient-migrated'>
                                <div>
                                    <button className={row.row.original.paciente_migrado ? "patient-migrated patient-migrated--new" : 'icon-patient'}>
                                        <div className={row.row.original.paciente_migrado ? "patient-migrated-new-label" : ''}>
                                            <FontAwesomeIcon icon={faUser} id={row.row.original.paciente_migrado ? "setPatient" : "none"} />
                                            <div />
                                            {row.row.original.paciente_migrado ?
                                                <UncontrolledTooltip placement="center" target="setPatient">
                                                    Paciente migrado desde otro aplicativo
                                                </UncontrolledTooltip>
                                                : null}
                                        </div>
                                    </button>
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                    <div>
                                        <label>{row.value} {row.row.original.num_documento} </label>
                                    </div>
                                    {row.row.original.paciente_migrado ? <div> <label><b>Migrado</b></label> </div> : null}
                                </div>
                            </div>
                            {row.row.original.has_alergies && this.state.showAlergies ?
                                <div className='wrap-info'>
                                    <div className='tooltip-alergies'>
                                        <Tooltip title="Alergias">
                                            <IconButton aria-label="launch" color="inherit" style={{ padding: 2, backgroundColor: '#FF5B1D', width: '1em', height: '1em' }}
                                                //disabled={this.state.patienteExist || this.props.dataEvent.id_cita !== "" ? false : true}
                                                onClick={() => {
                                                    this.handlerOpenModalAlergies(!this.state.openModalAlergies, row.row.original);
                                                }}
                                            >
                                                <FontAwesomeIcon icon={faDisease} style={{ color: '#FFFED2', width: '0.8em', height: '0.8em' }} />
                                            </IconButton>
                                        </Tooltip>
                                    </div>
                                </div>
                                : null
                            }
                        </div>
                    )
                },
                {
                    Header: 'NOMBRE',
                    accessor: 'fullname',
                    Cell: row => (<span className={`admision-new ${row.data[row.row.index].destacar == true ? 'effect-admision-new' : null}`}>
                        {row.value}
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            {row.row.original.requerimientos_especiales != undefined && this.state.askSpecialReq ? <>
                                <div><p style={{ marginLeft: 3, color: '#1086e0' }}>Req. Especiales:</p></div>
                                <div className='flex-row' style={{ justifyContent: 'center', flex: 'wrap' }}>
                                    {row.row.original.requerimientos_especiales.hospitalizado != undefined && row.row.original.requerimientos_especiales.hospitalizado != false ?
                                        <div className='element-icon-adm'> <FontAwesomeIcon icon={faPlusSquare} style={{ marginLeft: 3, color: '#1086e0' }} /></div>
                                        : null}
                                    {row.row.original.requerimientos_especiales.muletas != undefined && row.row.original.requerimientos_especiales.muletas != false ?
                                        <div className='element-icon-adm'> <FontAwesomeIcon icon={faCrutch} style={{ marginLeft: 3, color: '#1086e0' }} /></div>
                                        : null}
                                    {row.row.original.requerimientos_especiales.sillas != undefined && row.row.original.requerimientos_especiales.sillas != false ?
                                        <div className='element-icon-adm'> <FontAwesomeIcon icon={faWheelchair} style={{ marginLeft: 3, color: '#1086e0' }} /></div>
                                        : null}
                                    {row.row.original.requerimientos_especiales.sintomas_respiratorios != undefined && row.row.original.requerimientos_especiales.sintomas_respiratorios != false ?
                                        <div className='element-icon-adm'> <FontAwesomeIcon icon={faHeadSideCough} style={{ marginLeft: 3, color: '#1086e0' }} /></div>
                                        : null}
                                    {row.row.original.requerimientos_especiales.oxigeno != undefined && row.row.original.requerimientos_especiales.oxigeno != false ?
                                        <div className='element-icon-adm'> <FontAwesomeIcon icon={faLungs} style={{ marginLeft: 3, color: '#1086e0' }} /></div>
                                        : null}
                                    {row.row.original.requerimientos_especiales.camilla != undefined && row.row.original.requerimientos_especiales.camilla != false ?
                                        <div className='element-icon-adm'> <FontAwesomeIcon icon={faProcedures} style={{ marginLeft: 3, color: '#1086e0' }} /></div>
                                        : null}
                                    {row.row.original.requerimientos_especiales.ambulancia != undefined && row.row.original.requerimientos_especiales.ambulancia != false ?
                                        <div className='element-icon-adm'> <FontAwesomeIcon icon={faAmbulance} style={{ marginLeft: 3, color: '#1086e0' }} /></div>
                                        : null}
                                    {row.row.original.requerimientos_especiales.ninguno != undefined
                                        && row.row.original.requerimientos_especiales.ninguno != false
                                        && row.row.original.requerimientos_especiales.otro == false
                                        && row.row.original.requerimientos_especiales.ambulancia == false
                                        && row.row.original.requerimientos_especiales.camilla == false
                                        && row.row.original.requerimientos_especiales.oxigeno == false
                                        && row.row.original.requerimientos_especiales.sintomas_respiratorios == false
                                        && row.row.original.requerimientos_especiales.sillas == false
                                        && row.row.original.requerimientos_especiales.muletas == false
                                        && row.row.original.requerimientos_especiales.hospitalizado == false ?
                                        <div className='element-icon-adm'><span style={{ marginLeft: 3, color: '#1086e0' }}>Ninguno</span></div>
                                        : null}
                                </div>
                                {row.row.original.requerimientos_especiales.otro != undefined && row.row.original.requerimientos_especiales.otro != false ?
                                    <div className='element-icon-adm'><span style={{ marginLeft: 3, color: '#1086e0' }}> - {row.row.original.requerimientos_especiales.otroReq}</span></div>
                                    : null}
                            </> : null
                            }
                            {this.state.askFallingRisk &&
                                <div className='flex-column ' style={{ alignItems: 'center' }}>
                                    <div>Riesgo de caída: </div>
                                    <div>
                                        <span><FontAwesomeIcon icon={faCircle} style={{ color: this.verifyColorRisk(row.row.original.caidas) }} /> <b>{row.row.original.caidas.riesgo}</b></span>
                                    </div>
                                </div>
                            }
                        </div>
                    </span>)
                },
                {
                    Header: 'HORA CITA',
                    accessor: 'fecha_cita',
                    Cell: row => (<div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', padding: 0 }} className={`admision-new ${row.data[row.row.index].destacar == true ? 'effect-admision-new' : null}`}>
                        <div>
                            {row.value}
                        </div>
                        <div>
                            {row.row.original.fecha_cita_ddmmyyyy}
                        </div>
                    </div>)
                },
                {
                    Header: 'HORA INGRESO',
                    accessor: 'fecha_ingreso_completa',
                    Cell: row => (<div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', padding: 0 }} className={`admision-new ${row.data[row.row.index].destacar == true ? 'effect-admision-new' : null}`}>
                        <div>
                            {row.value}
                        </div>
                        <div>
                            {row.row.original.fecha_ingreso_admision}
                        </div>
                    </div>)
                },
                {
                    Header: 'SERVICIO(S)',
                    accessor: 'servName',
                    Cell: row => (
                        <div className='cell-info-table-admission'>
                            <div>
                                <span className={`admision-new ${row.data[row.row.index].destacar == true ? 'effect-admision-new' : null}`}>
                                    <b>{row.row.original.nombre_profesional != undefined && row.row.original.nombre_profesional != null ? 'DR(A). ' + row.row.original.nombre_profesional.toUpperCase() : ""}</b>
                                </span>
                                <hr style={{ color: '#55e5bb', backgroundColor: '#55e5bb', margin: '0.25em 0.25em', padding: 0 }}></hr>
                            </div>
                            <div>
                                <span className={`admision-new ${row.data[row.row.index].destacar == true ? 'effect-admision-new' : null}`}>
                                    {row.value}
                                </span>
                                <hr style={{ color: '#55e5bb', backgroundColor: '#55e5bb', margin: '0.25em 0.25em', padding: 0 }}></hr>
                            </div>
                            <div>
                                <span className={`admision-new ${row.data[row.row.index].destacar == true ? 'effect-admision-new' : null}`}>
                                    <b>{row.row.original.nombre_tercero != undefined && row.row.original.nombre_tercero != null ? row.row.original.nombre_tercero : ""}</b>
                                </span>
                            </div>
                        </div>
                    )
                }
            ],
            tableRowsData: this.state.data
        };

        return (
            <Card>
                <CardBody style={{ paddingTop: 4 }}>
                    <Col>
                        <form className="material-form" >
                            <Row>
                                <Col xs={12} sm={6} md={3}>
                                    <TextField
                                        className="material-form__field"
                                        label="Tipo  de documento"
                                        id="id-simplety-select"
                                        select
                                        defaultValue={null}
                                        value={this.state.typeOfDocument}
                                        onChange={(event) => {
                                            console.log(event);
                                            this.handlerTypeOfDocument(event.target.value);
                                        }}
                                    >
                                        <MenuItem className="material-form__option" key={0} value={''}>Ninguno</MenuItem>
                                        <MenuItem className="material-form__option" key={1} value={'TI'}>TI-Tarjeta de Identidad</MenuItem>
                                        <MenuItem className="material-form__option" key={2} value={'CC'}>CC-Cedula de Ciudadania</MenuItem>
                                        <MenuItem className="material-form__option" key={3} value={'PA'}>PA-Pasaporte</MenuItem>
                                        <MenuItem className="material-form__option" key={4} value={'RC'}>RC-Registro Civil</MenuItem>
                                        <MenuItem className="material-form__option" key={5} value={'CE'}>CE-Cedula de Extranjeria</MenuItem>
                                        <MenuItem className="material-form__option" key={6} value={'MS'}>MS-Menor sin Identificación</MenuItem>
                                        <MenuItem className="material-form__option" key={7} value={'AS'}>AS-Adulto sin Identificación</MenuItem>
                                        <MenuItem className="material-form__option" key={8} value={'SC'}>SC-Salvo Conducto</MenuItem>
                                        <MenuItem className="material-form__option" key={9} value={'CD'}>CD-Carnet Diplomatico</MenuItem>
                                        <MenuItem className="material-form__option" key={10} value={'CN'}>CN-Certificado de Nacido Vivo</MenuItem>
                                        <MenuItem className="material-form__option" key={11} value={'PE'}>PE-Permiso Especial de Permanencia</MenuItem>
                                        <MenuItem className="material-form__option" key={13} value={'PT'}>PT-Permiso por Protección Temporal</MenuItem>
                                        <MenuItem className="material-form__option" key={14} value={'SI'}>SI-Sin Identificación</MenuItem>
                                    </TextField>
                                </Col>
                                <Col xs={12} sm={6} md={3}>
                                    <TextField
                                        required
                                        id="document-standard-required"
                                        label="Documento"
                                        className="material-form__field"
                                        type="number"
                                        value={this.state.id}
                                        onChange={(e) => {
                                            this.handlerDocumentNumber(e.target.value);
                                        }}
                                        disabled={this.state.admission !== "" || (this.state.history !== "" && this.state.history != null)}
                                    />
                                </Col>
                                <Col xs={12} sm={6} md={3}>
                                    <TextField
                                        required
                                        id="first-name-standard-required"
                                        label="Primer nombre"
                                        type="text"
                                        className="material-form__field"
                                        value={this.state.names}
                                        onChange={(e) => {
                                            this.handlerNames(e.target.value);
                                        }}
                                    />
                                </Col>
                                <Col xs={12} sm={6} md={3}>
                                    <TextField
                                        required
                                        id="first-last-name-standard-required"
                                        label="Primer apellido"
                                        type="text"
                                        className="material-form__field"
                                        value={this.state.firstLastName}
                                        onChange={(e) => {
                                            this.handlerFirstLastName(e.target.value);
                                        }}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} sm={6} md={3}>
                                    <TextField
                                        required
                                        id="second-last-name-standard-required"
                                        label="Segundo apellido"
                                        type="text"
                                        className="material-form__field"
                                        value={this.state.secondLastName}
                                        onChange={(e) => {
                                            this.handlerSecondLastName(e.target.value);
                                        }}
                                    />
                                </Col>
                                <Col xs={12} sm={6} md={3}>
                                    <MuiPickersUtilsProvider utils={MomentUtils} >
                                        <ThemeProvider theme={defaultMaterialTheme}>
                                            <KeyboardDatePicker
                                                label="Fecha de la Admisión"
                                                openTo="date"
                                                variant="inline"
                                                value={this.state.date}
                                                onChange={(date) => {
                                                    this.handlerDate(date);
                                                }}
                                                format="DD/MM/YYYY"
                                                animateYearScrolling
                                                className="material-form__field"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}

                                                autoOk={true}
                                            />
                                        </ThemeProvider>
                                    </MuiPickersUtilsProvider>
                                </Col>
                                <Col xs={12} sm={6} md={3}>
                                    <TextField
                                        className="material-form__field"
                                        label="Estado"
                                        id="id-simplety-state-select"
                                        select
                                        defaultValue={null}
                                        value={this.state.stateAdmision}
                                        onChange={(event) => {
                                            this.handlerStateAdmision(event.target.value);
                                        }}
                                    >
                                        <MenuItem className="material-form__option" key={0} value={''}>SIN ESPECIFICAR</MenuItem>
                                        <MenuItem className="material-form__option" key={1} value={'Abierta'}>ABIERTA</MenuItem>
                                        <MenuItem className="material-form__option" key={2} value={'Cerrada'}>CERRADA</MenuItem>
                                        <MenuItem className="material-form__option" key={2} value={'Cancelada'}>ANULADA</MenuItem>
                                    </TextField>
                                </Col>
                                <Col xs={12} sm={6} md={3}>
                                    <TextField
                                        required
                                        id="admission-standard-required"
                                        label="N° Admision"
                                        type="number"
                                        className="material-form__field"
                                        value={this.state.admission}
                                        onChange={(e) => {
                                            this.handlerAdmission(e.target.value);
                                        }}
                                        disabled={this.state.id !== "" || (this.state.history !== "" && this.state.history != null)}
                                    />
                                </Col>
                            </Row>
                            <div className='form-admission-buttons'>
                                {this.state.date &&
                                    <div className='form-admission-info-date'>
                                        <div className='form-admission-buttons-search-date'>
                                            <ButtonGroupMui variant="text" aria-label="text primary button group">
                                                <ButtonMui className='group-button'
                                                    onClick={() => {
                                                        this.goToSelectedDate(this.state.date, false, true);
                                                    }
                                                    }>
                                                    <FontAwesomeIcon className='icon-selected-date' icon={faChevronCircleLeft} />
                                                </ButtonMui>
                                                <ButtonMui className='group-button'
                                                    onClick={() => {
                                                        this.goToSelectedDate(this.state.date, false, false);
                                                    }
                                                    }>
                                                    <FontAwesomeIcon className='icon-selected-date' icon={faCircle} />
                                                </ButtonMui>
                                                <ButtonMui className='group-button'
                                                    onClick={() => {
                                                        this.goToSelectedDate(this.state.date, true, false);
                                                    }
                                                    }>
                                                    <FontAwesomeIcon className='icon-selected-date' icon={faChevronCircleRight} />
                                                </ButtonMui>
                                            </ButtonGroupMui>
                                        </div>
                                        <div className='title-date'>
                                            <h5>{moment(this.state.datetwo !== null ? this.state.datetwo : this.state.date).format('DD [de] MMMM [de] YYYY')}</h5>
                                        </div>
                                    </div>
                                }
                                <div>
                                    <Button
                                        className='form-admission-buttons-search-admission'
                                        color="primary"
                                        size="sm"
                                        id="searchBtn"
                                        onClick={() => {
                                            this.setState({ indexPage: 0 });
                                            this.searchAdmissions(this.state.stateAdmision, false, true);
                                        }}
                                    >
                                        <SearchIcon />
                                        Buscar Admision
                                    </Button>
                                    <UncontrolledTooltip placement="top" target="searchBtn">
                                        Buscar Admision
                                    </UncontrolledTooltip>
                                </div>
                                {/* <div>
                                    <Button
                                        className='form-admission-buttons-search-admission'
                                        color="primary"
                                        size="sm"
                                        id="addBtn"
                                        onClick={() => {
                                            history.push({
                                                pathname: process.env.PUBLIC_URL + '/assitencial/add-admission',
                                                state: { dataPatient: null }
                                            });
                                        }}
                                    >
                                        <AddIcon />
                                        Agregar Admision
                                    </Button>
                                    <UncontrolledTooltip placement="top" target="addBtn">
                                        Agregar Admision
                                    </UncontrolledTooltip>
                                </div> */}
                            </div>
                        </form>
                        <div style={{ marginTop: 2 }}>
                            {/*<TableAdmissions BasicTableData={BasicTableData} />*/}
                            {this.state.isLoading ? <div className="text-center">
                                <Spinner animation="border" variant="success" />
                            </div>
                                : <DataReactTable
                                    title={'Resultados'}
                                    reactTableData={reactTableData}
                                    ReactTableActions={ReactTableActions}
                                    callbackRadioPharmacy={this.callbackRadioPharmacy}
                                    callbackTenCorrect={this.callbackTenCorrect}
                                    callbackFallingRisks={this.callbackFallingRisks}
                                    callbackupdateCanalization={this.callbackupdateCanalization}
                                    refresh={this.searchAdmissions}
                                    handlerIndexPage={this.handlerPageIndex}
                                    indexPageForm={this.state.indexPage}
                                    callbackHealthProfessional={this.callbackHealthProfessional}
                                />}
                        </div>
                    </Col>
                </CardBody>
                {
                    this.state.openModalAlergies && this.state.currentPatientInfo !== null ?
                        <AlergiesListToShow id_historia={this.state.currentPatientInfo.id_historia} openModaAlergie={this.state.openModalAlergies} handlerOpenModalAlergies={this.handlerOpenModalAlergies} />
                        : null
                }
                {this.state.showPDFCertAdmission ?
                    <Modal
                        open={this.state.showPDFCertAdmission}
                        aria-labelledby="simple-modal-title"
                        aria-describedby="simple-modal-description"
                        style={{ zIndex: 1000 }}
                    >
                        <div className="paperAppointment-flex" style={{ width: '80%', margin: 10, height: '80%' }}>
                            <IconButton style={{ float: 'right' }} onClick={() => {
                                this.handlerClosePDF();
                            }}>
                                <CloseIcon />
                            </IconButton>
                            <iframe id="pdfV" width="100%" height="90%" title="pdf-report" >
                            </iframe>
                        </div>
                    </Modal>
                    : null}
            </Card>)
    }
}

export default withStyles(styles, { withTheme: true })(FormAdmissions);